export const cancelModalContent = {
  title: 'Are you sure you want to cancel this process?',
  content: [
    'If you do this CompareBanks will not be able to access your data.',
    'If you decide to share your data with CompareBanks you will need to start this process again.',
  ],
  leftButtonLabel:
    'No button, to close the modal and back to the page click here',
  rightButtonLabel:
    ' Yes button, to confirm cancel process and redirect to start page click here',
}

export const mockSMSModalData = {
  type: 'SMS',
  sender: 'Bank1',
  content: [
    'From Bank1: 648470 is your One Time Password to share your CDR data.',
  ],
}

export const mockEmailModalData = {
  type: 'Email',
  sender: 'Bank1',
  emailTitle: 'Your CDR receipt',
  content: ['You have consented to share the following...'],
}

export const consentCancelModalData = {
  title: 'Are you sure you want to cancel this process?',
  content: [
    'If you cancel we will not be able to use your data to compare tailored banking products.',
    'If you decide to share your data with us you will need to start this process again.',
  ],
  leftButtonLabel:
    'No button, to close the modal and back to the page click here',
  rightButtonLabel:
    ' Yes button, to confirm the cancel process and forward to cancel confirm page click here',
}
